import { render, staticRenderFns } from "./UserBansInfoList.vue?vue&type=template&id=da3e21c4"
import script from "./UserBansInfoList.vue?vue&type=script&lang=js"
export * from "./UserBansInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports